import React from 'react';
import { USBButton } from '@usb-shield/forms-beta';
import styles from './technicalDifficulties.module.scss';

function TechnicalDifficulties({ restartRecommender }) {
    return (
        <>
            <div className={styles['main-content-wrapper']}>
                <div className={styles['main-left-content']}>
                    <h1 className={styles.title}>
                        Sorry, this wasn't supposed to happen.
                    </h1>
                    <div className={styles.content}>
                        <p>
                            Please restart the product recommender and
                            try again.
                        </p>
                    </div>

                    <USBButton
                        variant="primary"
                        ariaLabel="Restart product recommender"
                        onSubmit={restartRecommender}
                    >
                        Restart recommender
                    </USBButton>
                </div>
                <div className={styles['main-right-content']} />
            </div>
        </>
    );
}

export default TechnicalDifficulties;
